import type { IconSvgObject } from './types';

const Building04Icon: IconSvgObject = [
  ["path", { d: "M11 2V16C11 17.1046 10.1046 18 9 18H3", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M5 11.9889H11", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M17 16L18 16.0149M17 18.9851L18 19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M14 10L20.7022 12.5133C21.4829 12.8061 22 13.5523 22 14.386V22H14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M14 2V22H2L8.27545 2.69091C8.40935 2.27893 8.79329 2 9.22649 2H14Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default Building04Icon;
